import React, { useState } from 'react'
import Button from "@mui/material/Button";
import { CircularProgress } from "@mui/material";
import AlertDialog from '../../../components/AlertDialog/index.es6';

const EnableUser = (props) => {
  if (!props.user) {
    return ""
  }
  const [showWarning, setShowWarning] = useState(false);
  const disableCurrentUser = () => {
    setShowWarning(true)
    props.enableUser(props.user);
  }
  const cancel = () => {
    props.resetUserToEnable()
  }
  const handleUserEnabledSuccessfully = () => {
    props.resetEnableUserSuccessAlert()
    props.resetUserToEnable()
  }
  const handleUserEnableError = () => {
    props.resetUserToEnable()
  }
  return (
    <>
      <AlertDialog
        custom
        show={props.showEnableUserProgressAlert}
        size="sm"
        style={{ marginTop: '0', top: '30vh' }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'cancel'}
        showTitle={false}
        confirmBtnCssClass
      >
        <CircularProgress />
        <h2>Disabling User</h2>
      </AlertDialog>

      <AlertDialog
        warning
        show={!showWarning && props.user}
        size="sm"
        title={'Are you sure you want to activate ' + props.user.firstName}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => { cancel() }}
        onCancel={() => { disableCurrentUser() }}
        confirmBtnText={'Cancel'}
        showCancel={true}
        showConfirm={true}
        cancelBtnText={'Enable'}
        confirmBtnCssClass
      >
      </AlertDialog>
      <AlertDialog
        success
        show={props.showEnableUserSuccessAlert}
        size="sm"
        title={'User enabled successfully'}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => { handleUserEnabledSuccessfully() }}
        confirmBtnText={'Ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'Delete'}
        confirmBtnCssClass
      >
        <div >
          <Button variant="contained" onClick={() => { handleUserEnabledSuccessfully() }} style={{ background: 'green', }}>Ok</Button>
        </div>
      </AlertDialog>
      <AlertDialog
        show={props.showEnableUserErrorAlert}
        danger
        title={'Error enabling user'}
        onConfirm={() => handleUserEnableError()}
        confirmBtnText={'Try again'}
        confirmBtnCssClass
        showCancel={false}
        style={{ marginTop: '0', top: '30vh' }}
      >
        {'Could not enable user'}
      </AlertDialog>
    </>
  )
}

export default EnableUser